import { RISE_CONTRACT_ADDRESS, CASH_CONTRACT_ADDRESS } from "./config";

const CONTRACT_ADDRESS = {
  rise: RISE_CONTRACT_ADDRESS,
  cash: CASH_CONTRACT_ADDRESS,
};

const CONTRACT_HEXADDRESS = {
  rise: "41f56ae30d0f87a039485989f5c66e620f4c28ce61",
  cash: "417c503a569a8e62210bdce6b3e733272e154d08ab",
};

enum CONTRACT_TOKEN {
  RISE_CONTRACT_ADDRESS = "rise",
  CASH_CONTRACT_ADDRESS = "cash",
}

enum TOKENS {
  cash = "cash",
  rise = "rise",
}

const TICKERS = {
  cash: "CNS",
  rise: "CNR",
};

const TICKERS_TOKEN = {
  CNS: "cash",
  CNR: "rise",
};

const TOKEN_NAME = {
  cash: "Centric Cash",
  rise: "Centric Rise",
};

const TOKEN_DECIMALS = 100000000;

const TOKEN_CREATED = 1588118400000;

const TOKEN_DATA = {
  rise: {
    description:
      "Centric Rise (CNR) is a deflationary currency traded across the Centric payment network. Each unit of Centric Rise is pegged to trade at an agreed price denominated in USD which is enforced by the protocol at the point of exchange. The Centric Rise token is governed by the Centric Rise smart contract.",
    created: "30/04/2020 11:47:21",
    website: "https://www.centric.com",
    whitepaper: "https://www.centric.com/docs/Centric_Whitepaper.pdf",
    sociallinks: [
      {
        type: "twitter",
        link: "https://twitter.com/centricrise",
      },
      {
        type: "facebook",
        link: "https://www.facebook.com/centricfoundation",
      },
      {
        type: "telegram",
        link: "https://t.me/CentricChat",
      },
      {
        type: "discord",
        link: "https://discord.gg/KjwY64h",
      },
    ],
  },
  cash: {
    description:
      "Centric Cash (CNS) is created and burnt in exchange for Centric Rise (CNR). The Centric Cash token is governed by the Centric protocol and the Centric Cash smart contract.",
    created: "05/05/2020 08:41:26",
    website: "https://www.centric.com",
    cmcLink: "https://coinmarketcap.com/currencies/centric-cash/",
    geckoLink: "https://www.coingecko.com/en/coins/centric",
    whitepaper: "https://www.centric.com/docs/Centric_Whitepaper.pdf",
    sociallinks: [
      {
        type: "twitter",
        link: "https://twitter.com/centricrise",
      },
      {
        type: "facebook",
        link: "https://www.facebook.com/centricfoundation",
      },
      {
        type: "telegram",
        link: "https://t.me/CentricChat",
      },
      {
        type: "discord",
        link: "https://discord.gg/KjwY64h",
      },
    ],
    maximumSupply: "Elastic*",
  },
};

export {
  CONTRACT_ADDRESS,
  CONTRACT_HEXADDRESS,
  CONTRACT_TOKEN,
  TOKENS,
  TOKEN_NAME,
  TICKERS,
  TICKERS_TOKEN,
  TOKEN_DECIMALS,
  TOKEN_CREATED,
  TOKEN_DATA,
};
